<div class="row">
  <h3 class="col-lg-12" *ngIf="captureType === 'LABEL'">
    <span class="ant-page-header-heading-title ng-star-inserted">
      {{ value }}
    </span>
  </h3>
  <div class="col-lg-12" style="text-align: center;">
    <h5 nz-typography *ngIf="captureType === 'TITLE'">
      {{ value }}
    </h5>
  </div>
  <div class="col-lg-12" *ngIf="captureType === 'MESSAGE' && value" style="text-align: center;">
    <span *ngIf="captureType === 'MESSAGE' && value" nz-typography>{{value}}</span>
    <br> <br>
  </div>
  <a href="{{ value }}" target="_blank" *ngIf="captureType === formConfig.fieldTypes.link">
    {{ title }}
  </a>
</div>
